// Angular Imports
import { NgModule } from '@angular/core';

// This Module's Components
import { MobileFooterComponent } from './mobile-footer.component';

@NgModule({
    imports: [

    ],
    declarations: [
        MobileFooterComponent,
    ],
    exports: [
        MobileFooterComponent,
    ]
})
export class MobileFooterModule {

}



// WEBPACK FOOTER //
// ./src/app/ui/mobile-footer/mobile-footer.module.ts